import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';

import { VacationSchedule } from '@app/gen/vacations';

@injectable()
export class VacationStartMapper {
  constructor(private readonly format: FormatService) {}

  processVacationsSchedule(schedule: VacationSchedule) {
    return {
      id: schedule.id,
      status: schedule.status,
      year: schedule.year,
      activeTo: this.format.toDate(schedule.active_to),
      units: schedule.units,
      type: schedule.type,
      customType: schedule.custom_type,
    };
  }
}
